import { Injectable } from "@angular/core";
import { Network } from "@ionic-native/network/ngx";
import { Platform } from "@ionic/angular";

declare var Connection;

@Injectable()
export class Connectivity {

  //////////////////
  //Initialization//
  //////////////////

  onDevice: boolean;

  constructor(public platform: Platform, public network: Network) {
    this.onDevice = this.platform.is("cordova"); //check if the device is compatible with cordova
  }

  isOnline(): boolean {
    if (this.onDevice && this.network.type) {//run the if statement; if the device is compatible with cordova and if the network type is true 
      return this.network.type != "none"; //declare network type as not null
    } else {
      return navigator.onLine;  
    }
  }

  isOffline(): boolean {
    if (this.onDevice && this.network.type) {
      return this.network.type == "none"; //declare network type as null
    } else {
      return !navigator.onLine;
    }
  }

  watchOnline(): any {
    return this.network.onConnect();
  }

  watchOffline(): any {
    return this.network.onDisconnect();
  }
}
